var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"x-small":"","color":_vm.statusDisplay.color,"label":"","text-color":"white"}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v(_vm._s(_vm.statusDisplay.icon))]),_vm._v(" "+_vm._s(_vm.reportAssignment.status)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }